import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import { Contrato } from 'src/app/base/domain/contrato.model';
import { Page, ReturnAPI } from 'src/app/base/domain/return-api.model';
import { ContratoService } from 'src/app/base/services/contrato.service';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { ContratoListFilterOptions } from 'src/app/global/lists/contrato-list/contrato-list.component';
import { DialogService } from 'src/app/global/services/dialog.service';

type CategoriaSeek = 'novos' | 'repactuados' | 'liquidados';

interface SeekAbaState {
  contratos: Contrato[];
  totalRecords: number;
  loading: boolean;
  exportando: boolean;
  queryOptions: QueryOptions;
}

function criarEstadoAba(): SeekAbaState {
  return {
    contratos: [],
    totalRecords: 0,
    loading: false,
    exportando: false,
    queryOptions: new QueryOptions({ pageSize: 25 }),
  };
}

@Component({
  selector: 'app-seek-dashboard',
  templateUrl: './seek-dashboard.component.html',
  styleUrls: ['./seek-dashboard.component.css'],
})
export class SeekDashboardComponent implements OnInit {
  repactuados: SeekAbaState = criarEstadoAba();
  novos: SeekAbaState = criarEstadoAba();
  liquidados: SeekAbaState = criarEstadoAba();

  constructor(private router: Router, private contratoService: ContratoService, private dialogService: DialogService) {}

  ngOnInit(): void {
    this.listarRepactuados(0);
    this.listarNovos(0);
    this.listarLiquidados(0);
  }

  listarRepactuados(pageNumber: number): void {
    this.listar('repactuados', pageNumber);
  }

  listarNovos(pageNumber: number): void {
    this.listar('novos', pageNumber);
  }

  listarLiquidados(pageNumber: number): void {
    this.listar('liquidados', pageNumber);
  }

  onFilterRepactuados(options: ContratoListFilterOptions): void {
    this.aplicarFiltro(this.repactuados, options);
    this.listarRepactuados(0);
  }

  onFilterNovos(options: ContratoListFilterOptions): void {
    this.aplicarFiltro(this.novos, options);
    this.listarNovos(0);
  }

  onFilterLiquidados(options: ContratoListFilterOptions): void {
    this.aplicarFiltro(this.liquidados, options);
    this.listarLiquidados(0);
  }

  exportarExcel(categoria: CategoriaSeek): void {
    const aba = this[categoria];
    const options = new QueryOptions({ params: { ...aba.queryOptions.params, categoria } });
    aba.exportando = true;

    this.contratoService.exportarSeekDashboardExcel(options).subscribe(
      (response: Blob) => {
        aba.exportando = false;
        const hoje = new Date();
        FileSaver.saveAs(
          response,
          `dashboard-seek-${categoria}-${('00' + hoje.getDate()).slice(-2)}${('00' + (hoje.getMonth() + 1)).slice(
            -2,
          )}${hoje.getFullYear()}.xlsx`,
        );
      },
      () => {
        aba.exportando = false;
        this.dialogService.feedbackError('Não foi possível exportar os contratos para Excel.');
      },
    );
  }

  onDisclosure(contrato: Contrato): void {
    this.router.navigate(['base/contratos/acompanhamento-contrato-detail/' + contrato.id]);
  }

  private aplicarFiltro(aba: SeekAbaState, options: ContratoListFilterOptions): void {
    aba.queryOptions.params = {
      // "Todos os Postos" (id 0) nao envia uidPosto, e o SGF retorna os contratos de todos os postos
      uidPosto: options.postoSelecionado?.id ? options.postoSelecionado.uid : null,
      dataInicial: options.dataInicial ? options.dataInicial.getTime() : null,
      dataFinal: options.dataFinal ? options.dataFinal.getTime() : null,
    };
  }

  private listar(categoria: CategoriaSeek, pageNumber: number): void {
    const aba = this[categoria];
    aba.queryOptions.pageNumber = pageNumber + 1;
    aba.loading = true;

    const request =
      categoria === 'novos'
        ? this.contratoService.listarSeekDashboardNovos(aba.queryOptions)
        : categoria === 'repactuados'
        ? this.contratoService.listarSeekDashboardRepactuados(aba.queryOptions)
        : this.contratoService.listarSeekDashboardLiquidados(aba.queryOptions);

    request.subscribe((response: ReturnAPI<Page<Contrato>>) => {
      aba.loading = false;
      if (response.success) {
        aba.totalRecords = response.object.totalElements;
        aba.contratos = response.object.content;
      } else {
        aba.contratos = [];
        this.dialogService.feedbackReturnAPI(response, '');
      }
    });
  }
}
